var map = {
	"./nav-links.config.1.fr-CA.json": "YKF2",
	"./nav-links.config.1.json": "KlWY",
	"./nav-links.config.10.json": "JLJM",
	"./nav-links.config.11.json": "rst+",
	"./nav-links.config.12.json": "DB48",
	"./nav-links.config.13.fr-BE.json": "nMUL",
	"./nav-links.config.13.json": "DtZp",
	"./nav-links.config.14.json": "/VlC",
	"./nav-links.config.15.json": "QNiy",
	"./nav-links.config.16.de-LU.json": "KHlf",
	"./nav-links.config.16.json": "4XSi",
	"./nav-links.config.17.json": "ISsD",
	"./nav-links.config.18.json": "1zVr",
	"./nav-links.config.19.json": "zmKg",
	"./nav-links.config.2.json": "gWOc",
	"./nav-links.config.20.json": "8cuR",
	"./nav-links.config.21.json": "s9tm",
	"./nav-links.config.22.json": "xAJs",
	"./nav-links.config.23.json": "CXBV",
	"./nav-links.config.24.json": "V5Ti",
	"./nav-links.config.26.json": "x6qN",
	"./nav-links.config.27.json": "S54J",
	"./nav-links.config.28.en-HK.json": "UiTF",
	"./nav-links.config.28.json": "bRr/",
	"./nav-links.config.28.zh-CN.json": "T1oI",
	"./nav-links.config.3.json": "0uho",
	"./nav-links.config.4.json": "b+5l",
	"./nav-links.config.5.json": "4oCX",
	"./nav-links.config.6.json": "tGbq",
	"./nav-links.config.7.json": "QgMs",
	"./nav-links.config.8.fr-CA.json": "+bSf",
	"./nav-links.config.8.json": "XfEp",
	"./nav-links.config.9.json": "GIoi"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VhE2";